// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function ProtectedRoute({ children }) {
  const { currentUser, loading, mfaSetupRequired } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading application...</div>; // Or a spinner
  }

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // A system admin with no authenticator set up goes to set-up from any page.
  if (mfaSetupRequired && location.pathname !== '/enroll-mfa') {
    return <Navigate to="/enroll-mfa" replace />;
  }

  return children;
}
export default ProtectedRoute;
